import React, { useState, useRef, useEffect } from "react";
import { pushNotification } from "../../../../utils/notifications";
import Modal from "react-bootstrap/Modal";
import QuanLyMauHopDongApi from "../../../../service/QuanTriHeThong/QuanLyMauHopDong/QuanLyMauHopDongApi";
import CkEditorComponent from "../../../CkEditor/CkEditorComponent";

const GHI_CHU_FIELDS = [
  { label: "Ngày lập hợp đồng", value: "{$NgayLapHD}" },
  { label: "Người vay", value: "{$NguoiVay}" },
  { label: "CMTND", value: "{$CMTND}" },
  { label: "Nơi cấp", value: "{$NoiCap}" },
  { label: "Ngày cấp", value: "{$NgayCap}" },
  { label: "Địa chỉ", value: "{$DiaChi}" },
  { label: "Ngày sinh", value: "{$NgaySinh}" },
  { label: "Họ tên vợ/chồng", value: "{$HoTenVoChong}" },
  { label: "Số điện thoại vợ/chồng", value: "{$SDTVoChong}" },
  { label: "Thông tin khác", value: "{$ThongTinKhac}" },
  { label: "Số tiền bằng số", value: "{$sotien}" },
  { label: "Số tiền bằng chữ", value: "{$sotienchu}" },
  { label: "Số tiền còn lại", value: "{$sotienconlai}" },
  { label: "Số tiền còn lại bằng chữ", value: "{$sotienconlaibangchu}" },
  { label: "Số tiền gốc + lãi", value: "{$sotiengocvalai}" },
  { label: "Số tiền gốc + lãi bằng chữ", value: "{$sotiengocvalaibangchu}" },
  { label: "Thời hạn vay", value: "{$ThoiHan}" },
  { label: "Ngày vay", value: "{$NgayVay}" },
  { label: "Ngày kết thúc", value: "{$NgayKetThuc}" },
  { label: "Lãi suất (%)", value: "{$LaiXuat%}" },
  { label: "Lãi ngày", value: "{$LaiNgay}" },
  { label: "Phí một lần", value: "{$PhiMotLan}" },
  { label: "Phí hàng kỳ", value: "{$PhiHangKy}" },
  { label: "Phí hàng kỳ bằng chữ", value: "{$PhiHangKyBangChu}" },
  {
    label: "Phí phạt thanh toán trước hạn",
    value: "{$PhiPhatThanhToanTruocHan}",
  },
  { label: "Chiết khấu", value: "{$ChietKhau}" },
  { label: "Lãi suất trong hạn", value: "{$LaiSuatTrongHan}" },
  { label: "Phí thẩm định điều kiện vay", value: "{$PhiThamDinh}" },
  { label: "Phí quản lý tài sản", value: "{$PhiQuanLyTaiSan}" },
  { label: "Phí lưu giữ kho bãi", value: "{$PhiLuGiuKhoBai}" },
  { label: "Phạt chậm đóng lãi", value: "{$PhatChamDongLai}" },
  { label: "Phạt tất toán sớm", value: "{$PhatTatToanSom}" },
  { label: "Ghi chú", value: "{$GhiChu}" },
  { label: "Số điện thoại KH", value: "{$DienThoai}" },
  { label: "Tài sản thế chấp", value: "{$TaiSan}" },
  { label: "Phí kho", value: "{$PhiKho}" },
  { label: "Hộ khẩu thường trú", value: "{$HKTT}" },
  { label: "Người lập HĐ", value: "{$NguoiLapHD}" },
  { label: "Mã cho vay", value: "{$MaChoVay}" },
  { label: "Mã vạch tài sản 1", value: "{$CodeTaiSan1}" },
  { label: "Mã vạch tài sản 2", value: "{$CodeTaiSan2}" },
  { label: "Mã vạch tài sản 3", value: "{$CodeTaiSan3}" },
  { label: "Tên tài sản 1", value: "{$TenTaiSan1}" },
  { label: "Thuộc tính tài sản 11", value: "{$ThuocTinh11}" },
  { label: "Thuộc tính tài sản 12", value: "{$ThuocTinh12}" },
  { label: "Thuộc tính tài sản 13", value: "{$ThuocTinh13}" },
  { label: "Thuộc tính tài sản 14", value: "{$ThuocTinh14}" },
  { label: "Thuộc tính tài sản 15", value: "{$ThuocTinh15}" },
  { label: "Tên tài sản 2", value: "{$TenTaiSan2}" },
  { label: "Thuộc tính tài sản 21", value: "{$ThuocTinh21}" },
  { label: "Thuộc tính tài sản 22", value: "{$ThuocTinh22}" },
  { label: "Thuộc tính tài sản 23", value: "{$ThuocTinh23}" },
  { label: "Thuộc tính tài sản 24", value: "{$ThuocTinh24}" },
  { label: "Thuộc tính tài sản 25", value: "{$ThuocTinh25}" },
  { label: "Tổng số ngày vay", value: "{$TongSoNgayVay}" },
  { label: "Kỳ 1 từ ngày", value: "{$TimeKy11}" },
  { label: "Kỳ 1 đến ngày", value: "{$TimeKy12}" },
  { label: "Kỳ 2 từ ngày", value: "{$TimeKy21}" },
  { label: "Kỳ 2 đến ngày", value: "{$TimeKy22}" },
  { label: "Kỳ 3 từ ngày", value: "{$TimeKy31}" },
  { label: "Kỳ 3 đến ngày", value: "{$TimeKy32}" },
  { label: "Kỳ 4 từ ngày", value: "{$TimeKy41}" },
  { label: "Kỳ 4 đến ngày", value: "{$TimeKy42}" },
  { label: "Kỳ 5 từ ngày", value: "{$TimeKy51}" },
  { label: "Kỳ 5 đến ngày", value: "{$TimeKy52}" },
  { label: "Giờ tạo HĐ", value: "{$GioTaoHD}" },
  { label: "Giờ vay", value: "{$GioVay}" },
  { label: "Tên sản phẩm BHTG", value: "{$sanphamBHTG}" },
  { label: "Giá bán", value: "{$GiaBHTG}" },
  { label: "Tiền khách trả trước", value: "{$TiencocbandauBHTG}" },
  { label: "Số tiền phải trả mỗi kỳ", value: "{$TientrahangkyBHTG}" },
  { label: "Chữ ký số", value: "{$ChuKySo}" },
  { label: "Tiền thu hàng kỳ", value: "{$TienThuHangKy}" },
];

const ModalThemMoi = (props) => {
  const { show, onHide, Id, item, onSaved } = props;
  const realId = Id || item?.ContractId || 0;
  const [isSubmit, setIsSubmit] = useState(false);
  const initData = {
    ContractId: 0,
    ContractName: "",
    ContractContent: "",
    ContractDefault: false,
  };
  const [dataContract, setDataContract] = useState(initData);
  const [macDinh, setMacDinh] = useState(false);
  const editorRef = useRef();

  useEffect(() => {
    if (show) {
      const currentItem = item && item.ContractId > 0 ? item : null;
      const content = currentItem
        ? String(currentItem.ContractContent || "")
        : "";
      setDataContract({
        ContractId: currentItem ? currentItem.ContractId : 0,
        ContractName: currentItem ? currentItem.ContractName || "" : "",
        ContractContent: content,
        ContractDefault: currentItem
          ? currentItem.Keyword == "MAUHOPDONG_DEFAULT"
            ? true
            : false
          : false,
      });
      if (
        editorRef.current &&
        typeof editorRef.current.setData === "function"
      ) {
        editorRef.current.setData(content);
      }
    }
  }, [show, item]);

  const handleInsertField = (field) => {
    editorRef.current?.insertText(field);
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value ?? "";
    setDataContract((prev) => ({ ...prev, [field]: value }));
  };

  const handleHide = () => {
    if (onHide) {
      onHide();
    }
    setDataContract(initData);
  };

  const handleCheck = (e) => {
    const checked = e.target?.checked || false;
    setDataContract((prev) => ({
      ...prev,
      ContractDefault: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dataContract.ContractName.trim()) {
      pushNotification(
        "Vui lòng nhập tên hợp đồng!",
        "warning",
        "TOP_CENTER",
        2000,
      );
      return;
    }
    setIsSubmit(true);
    const editorData =
      editorRef.current?.getData() || dataContract.ContractContent;
    const payload = {
      ContractId: realId,
      ContractName: dataContract.ContractName,
      ContractContent: editorData,
      Keyword: dataContract.ContractDefault
        ? "MAUHOPDONG_DEFAULT"
        : "MAUHOPDONG",
    };
    try {
      const response = await QuanLyMauHopDongApi.addOrUpdate(payload);
      if (response && response.status === 200) {
        pushNotification("Thao tác thành công!", "success", "TOP_CENTER", 2000);
        if (onSaved) onSaved();
        handleHide();
      } else {
        pushNotification("Thao tác thất bại!", "error", "TOP_CENTER", 2000);
      }
    } catch (error) {
      console.error("Lỗi khi thêm/sửa mẫu hợp đồng:", error);
      pushNotification(
        "Có lỗi xảy ra, vui lòng thử lại!",
        "error",
        "TOP_CENTER",
        2000,
      );
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleHide}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-90w"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img
                src={
                  realId > 0
                    ? "/app-assets/images/icon-editphieuthuchi.png"
                    : "/app-assets/images/icon-tao-moi-don-nhap-hang.png"
                }
                alt="icon"
              />
            </span>
            {realId > 0 ? "Sửa mẫu hợp đồng" : "Thêm mới mẫu hợp đồng"}
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={handleHide}
          >
            <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
          </button>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="form form-horizontal">
              <div className="form-body">
                <div className="row">
                  <div
                    style={{
                      width: "350px",
                      flex: "0 0 350px",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                    }}
                  >
                    <div
                      className="card"
                      style={{
                        height: "calc(100vh - 220px)",
                        minHeight: 500,
                        overflowY: "auto",
                        width: "100%",
                      }}
                    >
                      <div className="card-header text-white bg-teal">
                        Ghi chú
                      </div>
                      <div
                        className="card-body p-0"
                        style={{
                          height: "100%",
                          maxHeight: "100%",
                          paddingBottom: 24,
                        }}
                      >
                        <ul className="list-group">
                          {GHI_CHU_FIELDS.map((field) => (
                            <li
                              key={field.value}
                              className="list-group-item"
                              style={{
                                cursor: "pointer",
                                padding: "0.7rem 1.2rem",
                              }}
                              onClick={() => handleInsertField(field.value)}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                {field.label}
                              </span>
                              <small className="text-muted">
                                ({field.value})
                              </small>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col"
                    style={{ width: "100%", maxWidth: "100%" }}
                  >
                    <div className="form-group">
                      <label
                        className="label-control color7-bold"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          marginBottom: 8,
                        }}
                      >
                        Tên hợp đồng <span className="canh-bao-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control input-sm"
                        value={dataContract.ContractName}
                        onChange={handleChange("ContractName")}
                        required
                        placeholder="Nhập tên hợp đồng"
                        style={{
                          fontSize: "16px",
                          height: "40px",
                          marginBottom: 16,
                        }}
                      />
                    </div>
                    <div className="form-group" style={{ width: "100%" }}>
                      <label
                        className="label-control color7-bold"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          marginBottom: 8,
                        }}
                      >
                        Nội dung
                      </label>
                      <div style={{ width: "100%" }}>
                        <CkEditorComponent
                          key={realId}
                          ref={editorRef}
                          value={dataContract.ContractContent}
                          onChange={(val) =>
                            setDataContract((prev) => ({
                              ...prev,
                              ContractContent: val,
                            }))
                          }
                          name_editor="ContractContentEditor"
                          style={{ minHeight: 400, width: "100%" }}
                        />
                      </div>
                      <div className="checkbox-parent-block">
                        <label className="checkbox-parent ">
                          <input
                            type="checkbox"
                            checked={dataContract.ContractDefault}
                            onChange={handleCheck}
                          />{" "}
                          <span>Mặc định</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={handleHide}
              disabled={isSubmit}
            >
              <span>
                <i className="mdi mdi-close"></i>
              </span>
              &nbsp; Đóng
            </button>
            <button
              type="submit"
              className="btn btn-new-main button-popup-submit"
              disabled={isSubmit}
            >
              <span>
                <img src="/app-assets/images/icon-send-v2.png" alt="save" />
              </span>
              &nbsp;{" "}
              {isSubmit ? "Đang lưu..." : realId > 0 ? "Lưu" : "Thêm mới"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default ModalThemMoi;
